import React from 'react'
import { Box, Stack } from '@mui/material'
import { AppBar, Footer, theme } from 'flanders-common-ui'
import { Outlet } from 'react-router-dom'
import PrivacyPolicy from '../legal/PrivacyPolicy'
import TermsAndConditions from '../legal/TermsAndConditions'

const VisitorLayout: React.FC = () => {
  return (
    <Box sx={{ display: 'flex', height: '100%' }}>
      <AppBar
        color="inherit"
        position="absolute"
        sx={{ boxShadow: theme.customShadows.subtle }}
      >
        {/* TODO: Logo */}
      </AppBar>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Stack
          alignItems="center"
          justifyContent="center"
          flexGrow={1}
          sx={{
            mt: 10,
          }}
        >
          <Outlet />
        </Stack>
        <Footer
          privacyPolicy={<PrivacyPolicy />}
          termsAndConditions={<TermsAndConditions />}
        />
      </Box>
    </Box>
  )
}

export default VisitorLayout
